import React from 'react';

export default function Content(html){
	return <div data-shaun="here" style={{color:'initial', textAlign: 'left', left: '0', margin:'16', overflowY: 'hidden', height: '74%' }} dangerouslySetInnerHTML={{ __html: html }} />;
}
